import React from 'react';


function Features() {
    return (
      <section id="features" >
  
  <div className="container flex flex-col md:px-4 mx-auto mt-5 space-y-12 md:space-y-0 md:flex">
  <div className="relative border-[1px] border-[#4B718D] p-14 flex flex-col space-y-3 md:space-y-0 md:space-x-6 md:flex-row">
          {/* <div className='absolute top-0 left-0 h-10 bg-[#4B74FB] w-24'></div> */}
              <div className="rounded-l-full bg-brightRedSupLight md:bg-transparent">
                  <div className=" items-center">
                      <h3 className="font-semibold text-2xl md:mb-4 md:hidden">
                        Why Hire Us
                      </h3>
                  </div>
              </div>
              
              <div className='space-y-6'>
                  <h3 className="text-[#4B74FB] hidden mb-4 text-5xl font-semibold md:block">
                      Why Hire Us
                  </h3>
                  <p className="text-darkGrayishBlue">
                    Employers 
                  <br/>
                    With over 15 years of experience in the tech industry, including 8 years in recruitment and 
                    6 years in the crypto space, Nako Mbelle, CEO of Fintech Recruiters, is the ideal choice for finding Fintech, web3, and AI talent. 
                    Fintech Recruiters, headquartered in Toronto, Canada, is a global full-service recruiting agency that embraces innovation. They were among the first to accept bitcoin and stablecoins as payment, demonstrating their forward-thinking approach. Trust Nako Mbelle and Fintech Recruiters to exceed your expectations and secure top-tier professionals worldwide.
                  </p>
                  <p>
                  <span>Timeline of Search:</span> 7 - 10 days for 1st qualified candidate submitted. Searches should take no longer than 30 days.
                  </p>
                  <p>
                  For our rates and terms please schedule a quick coffee chat below.
                  </p>
                  <p>
                    Candidates 
                    <br/>
                    Need help preparing for an upcoming interview at an AI, web3 or fintech startup?

                    Nako provides <a href='' className='font-[#4B74FB]'>career coaching services</a> specifically designed for individuals who are new to the fields of web3, fintech, or AI. Our aim is to help you identify your distinct skills and strengths, and effectively align them with the high-demand roles within these industries. Take advantage of your background, experience, and expertise to pursue a rewarding career in web3, fintech, or AI.
                  </p>
                    <div className="flex justify-center md:justify-start">
              <button className="p-3 px-6  text-white border-[1px] border-[#4B718D] baseline hover:bg-white">
                  <a href="#">Schedule a quick coffee chat today!</a>
              </button>
          </div>
        </div>
    </div>
    <div>
        <p>
            Don’t see a role that’s a fit in the current openings? 
            <a>Submit your resume</a> and we’ll get back to you when there’s an opening.
        </p>
    </div>
  
      
      <div className="flex flex-col space-y-8 md:w-2/3 ">
          
          <div className="relative border-[1px] border-[#4B718D] p-14 flex flex-col space-y-6 md:space-y-0 md:space-x-6 md:flex-row">
              
              <div className="rounded-l-full md:bg-transparent">
                  <div class=" items-center">
                      <h3 className="font-semibold text-2xl md:mb-4 md:hidden">
                          ENGINEERS
                      </h3>
                  </div>
              </div>
              
              <div className='space-y-6'>
                  <h3 className="hidden mb-4 text-5xl font-semibold md:block">
                    ENGINEERS
                  </h3>
                  <p className="text-nunito font-normal">
                     We are always on the lookout for exceptional Engineering talent. if you're an
                     with Rust, Go, C++, Typescript, Node, React, Next, Nest or Haskell, schedule a coffee chat with us.
                     <br/>
                     Passionate about low code apps, Mircoservices and Gitops? Submit your resume.
                     Whether you are a Backend, Full Stack, Frontend, Blockchain, Protocol Engineer, with VC Backend
                     startups leading the way in fintech, web3 and AI? We are looking for Cryptographers, systems
                     Engineers and Researcher with web3.
                    </p>
                <div className="flex justify-center md:justify-start">
                <button className="p-3 px-6  text-white border-[1px] border-[#4B718D] baseline hover:bg-white">
                    <a href="https://app.ismartrecruit.com/openJobWebsite?tenantId=E7pZmludGVjaHJlY3J1aXRlcnMuY29tX1JVSHNNdXhXdWIQ9e&view=grid&lang=en"> Let’s find your dream job</a>
                </button>
              </div>
              </div>
          </div>
  
          
          <div className="relative border-[1px] border-[#4B718D] p-14 flex flex-col space-y-3 md:space-y-0 md:space-x-6 md:flex-row">
          
              <div className="rounded-l-full bg-brightRedSupLight md:bg-transparent">
              
                  <div className="items-center">
                      <h3 className="font-semibold text-2xl md:mb-4 md:hidden">
                      Product & Design
                      </h3>
                  </div>
              </div>
              
              <div className='space-y-6'>
                  <h3 className="hidden mb-4 text-5xl font-bold md:block">
                  Product & Design
                  </h3>
                  <p className="text-darkGrayishBlue">
                  Our fintech, web3 and AI clients have high design standards. If you’re a Visual
                  or Product Designer, Motion Designer, UX/UI Engineer or Frontend Engineer with 
                  a strong eye for design, your work will be highly valued in these spaces.
                  You will join teams building the prototype of the future within their niche.
                  Join teams building web3, fintech and AI consumer-facing apps, market-
                  places, and solutions we thought were decades away. It’s a great time to a 
                  be a builder. Are you game?
                    </p>
                    <div className="flex justify-center md:justify-start">
              <button className="p-3 px-6  text-white border-[1px] border-[#4B718D] baseline hover:bg-white">
                  <a href="https://app.ismartrecruit.com/openJobWebsite?tenantId=E7pZmludGVjaHJlY3J1aXRlcnMuY29tX1JVSHNNdXhXdWIQ9e&view=grid&lang=en"> Let’s find your dream job</a>
              </button>
          </div>
              </div>
          </div>
      
          
          <div className="relative border-[1px] border-[#4B718D] p-14 flex flex-col space-y-3 md:space-y-0 md:space-x-6 md:flex-row">
          
              <div className="rounded-l-full bg-brightRedSupLight md:bg-transparent">
                  <div className=" items-center">
                      <h3 className="font-semibold text-2xl md:mb-4 md:hidden">
                      Sales & Marketing
                      </h3>
                  </div>
              </div>
              
              <div className='space-y-6'>
                  <h3 className="hidden mb-4 text-5xl font-semibold md:block">
                      Sales & Marketing
                  </h3>
                  <p className="text-darkGrayishBlue">
                  As a TradFi professional pivoting to fintech,web3 and AI careers is easier than
                  you think. Roles such as CFO, Finance Directors, FP&A Managers, Investment 
                  Analysts, Investor Relations and Data Analysts have transferable, one
                  can hit the ground running. There are a few exceptions such as 
                  Token economists or Crypto Traders, which requires a strong understanding of
                  DeFi.
                    </p>
                    <div className="flex justify-center md:justify-start">
              <button className="p-3 px-6  text-white border-[1px] border-[#4B718D] baseline hover:bg-white">
                  <a href="https://app.ismartrecruit.com/openJobWebsite?tenantId=E7pZmludGVjaHJlY3J1aXRlcnMuY29tX1JVSHNNdXhXdWIQ9e&view=grid&lang=en"> Let’s find your dream job</a>
              </button>
          </div>
              </div>
          </div>
          <div className="relative border-[1px] border-[#4B718D] p-14 flex flex-col space-y-3 md:space-y-0 md:space-x-6 md:flex-row">
          
              <div className="rounded-l-full bg-brightRedSupLight md:bg-transparent">
                  <div className="items-center">
                      <h3 className="font-semibold text-2xl md:mb-4 md:hidden">
                          Finance
                      </h3>
                  </div>
              </div>
              
              <div className='space-y-6'>
                  <h3 className="hidden mb-4 text-5xl font-semibold md:block">
                      Finance
                  </h3>
                  <p className="text-darkGrayishBlue">
                  As a TradFi professional pivoting to fintech,web3 and AI careers is easier than
                  you think. Roles such as CFO, Finance Directors, FP&A Managers, Investment 
                  Analysts, Investor Relations and Data Analysts have transferable, one
                  can hit the ground running. There are a few exceptions such as 
                  Token economists or Crypto Traders, which requires a strong understanding of
                  DeFi.
                  </p>
                  <div className="flex justify-center md:justify-start">
              <button className="p-3 px-6  text-white border-[1px] border-[#4B718D] baseline hover:bg-white">
                  <a href="https://app.ismartrecruit.com/openJobWebsite?tenantId=E7pZmludGVjaHJlY3J1aXRlcnMuY29tX1JVSHNNdXhXdWIQ9e&view=grid&lang=en"> Let’s find your dream job</a>
              </button>
          </div>
              </div>
          </div>
      </div>
  </div>
  </section>
    )
  }
  
  export default Features